import { convertDictionaryToViewLabelArray } from "utils-library/dist/utils";
export var EWrongWayResolutionPluginUserRights;
(function (EWrongWayResolutionPluginUserRights) {
    EWrongWayResolutionPluginUserRights["DOWNLOAD_ROAD_EVENTS"] = "DOWNLOAD_ROAD_EVENTS";
})(EWrongWayResolutionPluginUserRights || (EWrongWayResolutionPluginUserRights = {}));
const labelsDic = { [EWrongWayResolutionPluginUserRights.DOWNLOAD_ROAD_EVENTS]: 'Wrong Way Resolution / Download road events' };
export const EWrongWayResolutionPluginUserRightsArray = convertDictionaryToViewLabelArray(labelsDic);
